module.exports = __webpack_public_path__ + "img/apple-ar-3x.bf175630.png";